import { CurrencyPipe, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { BrowserModule, DomSanitizer, ɵDomSanitizerImpl } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AccountService } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { UI_COMPONENT_ADAPTER_PROVIDERS } from '@app/finxone-web-frontend/app/lib/ui-component-adapters/ui-component-adapters.providers';
import { WorkflowFrontendConfig } from './libs/services/config-service/config.type';
import { MetadataService } from '@app/finxone-web-frontend/app/lib/services/metadata-service/metadata-service.service'; // eslint-disable-line
import { AccountState } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { BeneficiaryState } from '@app/finxone-web-frontend/app/lib/state/beneficiary.state';
import { BulkPaymentHistoryState } from '@app/finxone-web-frontend/app/lib/state/bulk-payment-history.state';
import { CardManagementState } from '@app/finxone-web-frontend/app/lib/state/card-management.state';
import { CardState } from '@app/finxone-web-frontend/app/lib/state/card.state';
import { ChartState } from '@app/finxone-web-frontend/app/lib/state/chart.state';
import { FormActionState } from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { ImageActionState } from '@app/finxone-web-frontend/app/lib/state/image-submision.state';
import { MonthlySummaryState } from '@app/finxone-web-frontend/app/lib/state/monthlysummary.state';
import { OrganisationState } from '@app/finxone-web-frontend/app/lib/state/organisation.state';
import { RoleState } from '@app/finxone-web-frontend/app/lib/state/role.state';
import { TransactionState } from '@app/finxone-web-frontend/app/lib/state/transaction.state';

import { ProfileState } from '@app/finxone-web-frontend/app/lib/state/user-profile.state';
import { UiComponentsModule } from '@finxone-platform/ui-components';
import { SortablejsModule } from '@maksim_m/ngx-sortablejs';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { LOCAL_STORAGE_ENGINE, NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsModule, Store } from '@ngxs/store';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import player from 'lottie-web/build/player/lottie_svg';
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';
import { AlertHandlerModule } from './alert-handler/alert-handler.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ActingOrgBannerComponent } from './modules/acting-org/acting-org-banner.component';
import { AppAuthGuard } from './auth.guard';
import { LoginComponent } from './libs/components/login/login.component';
import { ErrorHandlerInterceptor } from './libs/error-interceptor';
import { httpInterceptor } from './libs/http-interceptor';
import { CdkOverlayContainer } from './libs/overlay/cdk-overlay-container';
import { ActiveConfigService } from './libs/services/active-config/active-config.service';
import { ApiService } from './libs/services/api-service/api.service';
import { SystemConfigService } from './libs/services/system-config/system-config.service';
import { AppGridState } from './libs/state/app-grid.state';
import { CompanyDetailState } from './libs/state/company.detail.state';
import { CopyPasteState } from './libs/state/copy-paste.state';
import { PersonalProfileState } from './libs/state/personal-profile.state';
import { ProgressBarWorkflowState } from './libs/state/progress-bar-workflow.state';
import { ProjectsState } from './libs/state/project.state';
import { TeamMembersState } from './libs/state/team-members.state';
import { TokenInterceptor } from './libs/token-interceptor';
import { MockAccountService } from './modules/ui-builder/libs/mock-services/account-service.service';
import { MockConfigService } from './modules/ui-builder/libs/mock-services/config-service.service';
import { MockMetadataService } from './modules/ui-builder/libs/mock-services/metadata-service.service';
import { MockWorkflowFormsService } from './modules/ui-builder/libs/mock-services/workflow-forms.service';

import { OverlayContainer } from '@angular/cdk/overlay';
import { FooterNavbarComponent } from '@app/finxone-web-frontend/app/Modules/layouts/footer-navbar/footer-navbar.component';

import { CardManagementService } from '@app/finxone-web-frontend/app/lib/services/card-management-service/card-management-service';
import { DocumentService } from '@app/finxone-web-frontend/app/lib/services/document-service/document.service';
import { ExchangeService } from '@app/finxone-web-frontend/app/lib/services/exchange-service/exchange-service.service';
import { KeycloakCustomService } from '@app/finxone-web-frontend/app/lib/services/keycloak-wrapper-service/keycloak-custom.service';
import { NotificationService } from '@app/finxone-web-frontend/app/lib/services/notification-service/notification-service.service';
import { ApiLoadingState } from '@app/finxone-web-frontend/app/lib/state/api-loading.state';
import { AppDataState } from '@app/finxone-web-frontend/app/lib/state/app-data.state';
import { BulkPaymentListState } from '@app/finxone-web-frontend/app/lib/state/bulk-payment.state';
import { CopResponseState } from '@app/finxone-web-frontend/app/lib/state/cop-response.state';
import { DepositAccountInfoState } from '@app/finxone-web-frontend/app/lib/state/deposit-account-info.state';
import { NotificationState } from '@app/finxone-web-frontend/app/lib/state/notifications.state';
import { PageContextState } from '@app/finxone-web-frontend/app/lib/state/page-context.state';
import { PaymentRequestState } from '@app/finxone-web-frontend/app/lib/state/payment-request.state';
import { PaymentSummaryCounterState } from '@app/finxone-web-frontend/app/lib/state/payment-summary-counters.state';
import { ProjectSettingsState } from '@app/finxone-web-frontend/app/lib/state/project-settings.state';
import { CodeEditorModule } from '@ngstack/code-editor';
import { WorkflowIconRegistry } from '@finxone-platform/shared/frontend';
import { HlmTabsService } from '@spartan-ng/ui-tabs-helm';
import { provideLottieOptions } from 'ngx-lottie';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PreviewDeviceHolderComponent } from './device-holder/preview-device-holder.component';
import { CdkOverlayContainerDirective } from './libs/overlay/cdk-overlay-container.directive';
import { RequestUrlSanitizerInterceptor } from './libs/request-url-santizer-interceptor';
import { GlobalThemeFormFactoryService } from './libs/services/global-theme-utility/global-theme-form-factory.service';
import { NgxsMockDataProviderService } from './libs/services/ngxs-mock-data-provider/ngxs-mock-data-provider.service';
import { OrganisationService } from './libs/services/organisation.service';
import { RouteService } from './libs/services/route-service/route.service';
import { SocketService } from './libs/services/socket-service/socket-service.service';
import { GlobalThemeState } from './libs/state/global-theme.state';
import { ProjectAlertsState } from './libs/state/project-alerts.state';
import { ProjectNotificationsState } from './libs/state/project-notifications.state';
import { SharedModule } from './modules/shared/shared.module';
import { MockCardManagementService } from './modules/ui-builder/libs/mock-services/card-management-service';
import { MockDocumentService } from './modules/ui-builder/libs/mock-services/documents.service';
import { MockExchangeService } from './modules/ui-builder/libs/mock-services/exchange-service.service';
import { MockKeycloakCustomService } from './modules/ui-builder/libs/mock-services/keycloak-custom.service';
import { MockNotificationService } from './modules/ui-builder/libs/mock-services/notification-service.service';
import { MockTransactionService } from './modules/ui-builder/libs/mock-services/transaction.service';

import { BeneficiaryFormService } from '@app/finxone-web-frontend/app/Modules/shared/widgets/add-beneficiary-v2/beneficiary-form.service';
import { ChartService } from '@app/finxone-web-frontend/app/lib/services/chart-service/chart-service.service';
import { DataSourceService } from '@app/finxone-web-frontend/app/lib/services/data-source-service/data-source.service';
import { MessagingSocketService } from '@app/finxone-web-frontend/app/lib/services/messaging-socket-service/messaging-socket-service.service';
import { ResponsiveHideConditionsService } from '@app/finxone-web-frontend/app/lib/services/responsive-hide-conditions-service/responsive-hide-conditions.service';
import { RecurringPaymentsService } from '@app/finxone-web-frontend/app/lib/services/recurring-payments-service/recurring-payments.service';
import { SavingsAccountService } from '@app/finxone-web-frontend/app/lib/services/savings-account-service/savings-account.service';
import { StateService } from '@app/finxone-web-frontend/app/lib/services/state-service/state.service';
import { SupportChatsService } from '@app/finxone-web-frontend/app/lib/services/support-chats-service/support-chats.service';
import { TransactionService } from '@app/finxone-web-frontend/app/lib/services/transaction-service/transaction.service';
import { WorkflowFormsService } from '@app/finxone-web-frontend/app/lib/services/workflow-forms/workflow-forms.service';
import { PaymentState } from '@app/finxone-web-frontend/app/lib/state/payment.state';
import { RecurringPaymentsState } from '@app/finxone-web-frontend/app/lib/state/recurring-payments.state';
import { SavingsAccountState } from '@app/finxone-web-frontend/app/lib/state/savings-account.state';
import { MockBeneficiaryFormService } from './modules/ui-builder/libs/mock-services/beneficiary-form.service';
import { MockChartService } from './modules/ui-builder/libs/mock-services/chart-service.service';
import { MockDataSourceService } from './modules/ui-builder/libs/mock-services/data-source.service';
import { MockMessagingSocketService } from './modules/ui-builder/libs/mock-services/messagin-socket-service.service';
import { MockRecurringPaymentsService } from './modules/ui-builder/libs/mock-services/recurring-payments.service';
import { MockResponsiveHideConditionsService } from './modules/ui-builder/libs/mock-services/responsive-hide-conditions.service';
import { MockSavingsAccountService } from './modules/ui-builder/libs/mock-services/savings-account.service';
import { MockSupportChatsService } from './modules/ui-builder/libs/mock-services/support-chats.service';
import { SavingsProductsState } from '@app/finxone-web-frontend/app/lib/state/savings-products.state';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { definePreset } from '@primeng/themes';

const keycloakService = new KeycloakService();

const unauthenticatedRoutes = ['/back-office/reset-password'];

function isAuthenticatedRoute(route: string) {
  return !unauthenticatedRoutes.some((unauthenticatedRoute) => route.endsWith(unauthenticatedRoute));
}

export const ngxsWorkflowFrontendStateStorageMethods = [
  {
    key: ProjectsState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: AppGridState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: ProgressBarWorkflowState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: TeamMembersState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: PersonalProfileState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: CompanyDetailState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: CopyPasteState,
    engine: LOCAL_STORAGE_ENGINE,
  },
  {
    key: GlobalThemeState,
    engine: LOCAL_STORAGE_ENGINE,
  },
];

const FinxonePreset = definePreset(Lara, {
  // Lara's default primary is emerald; every component that is not overridden below would
  // otherwise show green (tab bars, selected options, focus rings). The builder's primary is
  // the azure the rest of the chrome uses.
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
  components: {
    accordion: {
      content: {
        borderWidth: '0',
        background: 'var(--color-workflow-white)',
        color: 'var(--color-workflow-black)',
        padding: '0',
      },
    },
    listbox: {
      root: {
        borderColor: 'transparent',
        borderRadius: '0',
      },
      option: {
        padding: '0',
      },
      list: {
        padding: '0',
      },
    },
    select: {
      root: {
        focusBorderColor: 'var(--color-finxone-azure)',
        hoverBorderColor: 'var(--color-finxone-azure)',
        focusRing: {
          color: 'var(--color-finxone-azure)',
          shadow: '0 0 0 3px var(--color-finxone-azure-12)',
        },
      },
      option: {
        selectedFocusBackground: 'var(--color-finxone-azure)',
        selectedFocusColor: 'var(--color-workflow-white)',
        selectedBackgroundColor: 'var(--color-finxone-azure-12)',
        selectedColor: 'inherit',
      },
    },
  },
});

@NgModule({
  declarations: [AppComponent, LoginComponent, PreviewDeviceHolderComponent],
  exports: [RouterModule],
  bootstrap: [AppComponent],
  imports: [
    ActingOrgBannerComponent,
    CodeEditorModule.forRoot({
      editorVersion: '0.47.0',
    }),
    CdkOverlayContainerDirective,
    KeycloakAngularModule,
    BrowserModule,
    UiComponentsModule,
    NgxsModule.forRoot([
      AppDataState,
      AccountState,
      FormActionState,
      CardState,
      CardManagementState,
      TransactionState,
      MonthlySummaryState,
      ChartState,
      ProfileState,
      BeneficiaryState,
      CopResponseState,
      NotificationState,
      PageContextState,
      OrganisationState,
      ImageActionState,
      RoleState,
      ApiLoadingState,
      PaymentState,
      SavingsProductsState,
      // workflow states
      ProjectsState,
      AppGridState,
      ProgressBarWorkflowState,
      TeamMembersState,
      PersonalProfileState,
      CompanyDetailState,
      CopyPasteState,
      BulkPaymentListState,
      PaymentRequestState,
      BulkPaymentHistoryState,
      ProjectSettingsState,
      ProjectAlertsState,
      ProjectNotificationsState,
      GlobalThemeState,
      PaymentSummaryCounterState,
      DepositAccountInfoState,
      SavingsAccountState,
      RecurringPaymentsState,
    ]),
    NgxsStoragePluginModule.forRoot({
      // Default everything to local storage
      storage: StorageOption.LocalStorage,
      keys: '*',
    }),
    BrowserAnimationsModule,
    AppRoutingModule,
    MatIconModule,
    SortablejsModule.forRoot({ animation: 150 }),
    // must be after all other ngxs modules
    NgxsReduxDevtoolsPluginModule.forRoot(),
    NgxSmartModalModule.forRoot(),
    SharedModule,
    AlertHandlerModule,
    FooterNavbarComponent,
  ],
  providers: [
    providePrimeNG({
      theme: {
        preset: FinxonePreset,
        options: {
          darkModeSelector: 'none',
        },
      },
    }),
    ...UI_COMPONENT_ADAPTER_PROVIDERS,
    SocketService,
    ConfirmationService,
    MessageService,
    provideLottieOptions({
      player: () => player,
    }),
    { provide: MatIconRegistry, useClass: WorkflowIconRegistry },
    provideLottieOptions({
      player: () => player,
    }),
    DatePipe,
    CurrencyPipe,
    NgxSmartModalService,
    GlobalThemeFormFactoryService,
    { provide: OverlayContainer, useClass: CdkOverlayContainer },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: httpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestUrlSanitizerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    AppAuthGuard,
    {
      provide: AccountService,
      useFactory: (store: Store) => new MockAccountService(store),
      deps: [Store],
    },
    {
      provide: SavingsAccountService,
      useValue: new MockSavingsAccountService(),
    },
    {
      provide: NotificationService,
      useFactory: (store: Store) => {
        return new MockNotificationService(store);
      },
      deps: [Store],
    },
    {
      provide: ExchangeService,
      useFactory: (store: Store) => {
        return new MockExchangeService(store);
      },
      deps: [Store],
    },
    {
      provide: TransactionService,
      useFactory: () => {
        return new MockTransactionService();
      },
    },
    {
      provide: DocumentService,
      useFactory: () => {
        return new MockDocumentService();
      },
    },
    {
      provide: ChartService,
      useFactory: () => {
        return new MockChartService();
      },
    },
    {
      provide: MetadataService,
      useValue: new MockMetadataService(),
    },
    {
      provide: KeycloakCustomService,
      useValue: new MockKeycloakCustomService(),
    },
    {
      provide: KeycloakService,
      useValue: keycloakService,
    },
    {
      provide: SupportChatsService,
      useValue: new MockSupportChatsService(),
    },
    {
      provide: RecurringPaymentsService,
      useFactory: (store: Store) => new MockRecurringPaymentsService(store),
      deps: [Store],
    },
    {
      provide: CardManagementService,
      useFactory: (store: Store) => {
        return new MockCardManagementService(store);
      },
      deps: [Store],
    },
    {
      provide: ConfigService,
      useFactory: (
        systemConfigSevice: SystemConfigService,
        activeConfigService: ActiveConfigService,
        apiService: ApiService,
        registry: MatIconRegistry,
        domSanitizer: DomSanitizer,
        store: Store,
        routeService: RouteService,
        stateService: StateService,
      ) =>
        new MockConfigService(
          systemConfigSevice,
          activeConfigService,
          apiService,
          registry,
          domSanitizer,
          store,
          routeService,
          stateService,
        ),
      deps: [
        SystemConfigService,
        ActiveConfigService,
        ApiService,
        MatIconRegistry,
        DomSanitizer,
        Store,
        RouteService,
        StateService,
      ],
    },
    {
      provide: DomSanitizer,
      useValue: new ɵDomSanitizerImpl(document),
    },
    {
      provide: HlmTabsService,
      useValue: new HlmTabsService(),
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, OrganisationService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => null,
      multi: true,
      deps: [NgxsMockDataProviderService],
    },
    {
      provide: WorkflowFormsService,
      useClass: MockWorkflowFormsService,
    },
    {
      provide: ResponsiveHideConditionsService,
      useClass: MockResponsiveHideConditionsService,
    },
    {
      provide: BeneficiaryFormService,
      useClass: MockBeneficiaryFormService,
    },
    {
      provide: DataSourceService,
      useClass: MockDataSourceService,
    },
    {
      provide: MessagingSocketService,
      useClass: MockMessagingSocketService,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}

export function initializeKeycloak(keycloak: KeycloakService, orgService: OrganisationService) {
  return async () => {
    const config: WorkflowFrontendConfig = await fetch('/assets/config.json').then((response) =>
      response.json(),
    );
    await keycloak
      .init({
        config: {
          url: config.api_endpoints['auth_service'],
          realm: config.auth.realm,
          clientId: config.auth.client_id,
        },
        initOptions: {
          onLoad: 'check-sso',
          silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        },
        shouldAddToken: (request) => {
          // if a get request and on /assets then don't add auth header to httpclient
          const { url } = request;
          const acceptablePaths = ['.svg'];
          const isAcceptablePathMatch = acceptablePaths.some((path) => url.includes(path));
          return !isAcceptablePathMatch;
        },
      })
      .then(async (auth) => {
        if (auth) {
          const token = await keycloak.getToken();
          orgService.decodeJWT(token);
          sessionStorage.setItem('token', token);
        } else if (isAuthenticatedRoute(globalThis.location.pathname)) {
          keycloak.login();
        }
      });
  };
}
